import { Navigate, Outlet } from 'react-router-dom';
import { useAppAuth } from '@/lib/useAppAuth';
import { useOpenLogin } from '@/store/authModalStore';
import { useEffect } from 'react';

/**
 * Route guard that requires a live session.
 *
 * A registered account browses the app as fully authenticated even while
 * onboarding (email verification, terms) is unfinished — navigation is not a
 * gated action; the funnel resumes only when they attempt an authenticated
 * *post* action (see `useAppAuth().isOnboarded` consumers). True visitors with
 * no session are redirected to `/` with the login modal opened.
 */
export function ProtectedRoute() {
  const { isAuthenticated } = useAppAuth();
  const openLogin = useOpenLogin();

  useEffect(() => {
    if (!isAuthenticated) openLogin();
  }, [isAuthenticated, openLogin]);

  if (!isAuthenticated) return <Navigate to="/" replace />;
  return <Outlet />;
}
